import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {map} from 'lodash';

// PrimeReact components
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from 'primereact/button';
import {Dropdown} from 'primereact/dropdown';

// Catalog constants
import {ShelfTypes} from '../catalog/catalog-constants';

// Styles
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

/*
  ManageShelfBean.java:getSortOptions() restricted the sort options available to the
  user based on AVAILABLE_ASSET_SORT_OPTIONS. This is implemented in React by filtering
  shelfTypes for ShelfTypes.ASSET.

  The Catalog enum SortingMethod.java has an extended list of Sorting Methods which is
  reproduced below with shelfTypes as an empty array.

  For reference the declaration of AVAILABLE_ASSET_SORT_OPTIONS is below:-

	List<SortingMethod> AVAILABLE_ASSET_SORT_OPTIONS =
	Arrays.asList(SortingMethod.DOWNLOAD_COUNT,
			          SortingMethod.MANUAL,
					      SortingMethod.MPAA,
					      SortingMethod.START_DATE,
					      SortingMethod.TITLE,
					      SortingMethod.USER_RATING,
					      SortingMethod.YEAR);
 */

const SortingMethods = [
    {label: 'Download Count', value: 'DOWNLOAD_COUNT', shelfTypes: [ShelfTypes.ASSET]},
    {label: 'Manual', value: 'MANUAL', shelfTypes: [ShelfTypes.ASSET]},
    {label: 'MPAA', value: 'MPAA', shelfTypes: [ShelfTypes.ASSET]},
    {label: 'Start Date', value: 'START_DATE', shelfTypes: [ShelfTypes.ASSET]},
    {label: 'Title', value: 'TITLE', shelfTypes: [ShelfTypes.ASSET]},
    {label: 'User Rating', value: 'USER_RATING', shelfTypes: [ShelfTypes.ASSET]},
    {label: 'Year', value: 'YEAR', shelfTypes: [ShelfTypes.ASSET]},
    {label: 'Default', value: 'DEFAULT', shelfTypes: []},
    {label: 'Actor', value: 'ACTOR', shelfTypes: []},
    {label: 'Score', value: 'SCORE', shelfTypes: []},
    {label: 'Genre', value: 'GENRE', shelfTypes: []},
    {label: 'Price', value: 'PRICE', shelfTypes: []},
    {label: 'Resolution', value: 'RESOLUTION', shelfTypes: []},
    {label: 'GUID', value: 'GUID', shelfTypes: []},
    {label: 'Season Episode', value: 'SEASON_EPISODE', shelfTypes: []},
];

const NetworkSortingMethods = [
    {label: 'Display Name', value: 'DISPLAY_NAME'},
    {label: 'Number of Assets', value: 'NUMBER_OF_ASSETS'},
    {label: 'Download Count', value: 'DOWNLOAD_COUNT'},
];

class sortOptionList extends Component {
    state = {
        selectedSortOption: null,
    };

    changeSortOption = e => {
        e.preventDefault();
        this.setState({selectedSortOption: e.target.value});
    };

    addSortOption = event => {
        const {shelfType, updateSortOptionList} = this.props;
        const {selectedSortOption} = this.state;
        const optionsInitial = this.fetchSortingMethods(shelfType);
        const mySelectedSortOption = selectedSortOption || optionsInitial[0].value || '';

        event.preventDefault();

        updateSortOptionList({
            class: shelfType === 'ASSET' ? 'AssetSortOption' : 'NetworkSortOption',
            method: mySelectedSortOption,
            order: 'ASCENDING',
            sortShelf: shelfType,
        });

        const options = this.fetchSortingMethods(shelfType);
        this.setState({selectedSortOption: options.length ? options[0].value : ''});
    };

    updateSortOrder = event => {
        const {updateSortOrder} = this.props;
        const {selectedOptions} = this.state;

        event.preventDefault();

        this.setState({selectedOptions}, () => updateSortOrder(selectedOptions));
    };

    deleteSelectedSortOrders = event => {
        const {deleteSelectedSortOptions} = this.props;
        const {selectedOptions} = this.state;

        event.preventDefault();

        this.setState({selectedOptions: []}, () => deleteSelectedSortOptions(selectedOptions));
    };

    reorderSortOptionList = e => {
        const {reorderSortOptionList} = this.props;
        reorderSortOptionList(e);
    };

    fetchSortingMethods = shelfTypeIdx => {
        const {sortOptions} = this.props;
        let options = [];

        if (shelfTypeIdx === 'ASSET') {
            const assetSortingMethods = SortingMethods.filter(sortingMethod =>
                sortingMethod.shelfTypes.includes(ShelfTypes.ASSET)
            );
            options = map(assetSortingMethods, sortOption => ({
                label: sortOption.label,
                value: sortOption.value,
            }));
        } else if (shelfTypeIdx === 'NETWORK') {
            options = map(NetworkSortingMethods, sortOption => ({
                label: sortOption.label,
                value: sortOption.value,
            }));
        }

        return options.filter(item => !sortOptions.includes(sortOptions.find(el => el.method === item.value)));
    };

    render() {
        const {shelfType, sortOptions} = this.props;
        const {selectedSortOption, selectedOptions} = this.state;

        const options = this.fetchSortingMethods(shelfType);
        return (
            <div>
                <DataTable
                    reorderableColumns={true}
                    reorderableRows={true}
                    selection={selectedOptions}
                    value={sortOptions}
                    onRowReorder={e => this.reorderSortOptionList(e.value)}
                    onSelectionChange={e => this.setState({selectedOptions: e.value})}
                >
                    <Column rowOrderIcon="e95f" rowReorder={true} style={{width: '3em'}} />
                    <Column header="Select All " selectionMode="multiple" style={{width: '10em'}} />
                    <Column field="method" header="Sorting Method" />
                    <Column field="order" header="Order" />
                </DataTable>
                <div className="p-d-flex" style={{marginBottom: '1em'}}>
                    <Dropdown
                        disabled={!options.length}
                        filterPlaceholder="Select Sort Option"
                        id="cboSortOption"
                        options={options}
                        showClear={false}
                        style={{leftMargin: '1em', width: '200px'}}
                        value={selectedSortOption || (options.length ? options[0].value : '')}
                        onChange={this.changeSortOption}
                    />
                    <Button
                        disabled={!options.length}
                        label="Add"
                        style={{marginLeft: '1em', height: 33, marginTop: 3}}
                        onClick={this.addSortOption}
                    />
                </div>
                <div className="p-d-flex p-flex-row">
                    <Button
                        disabled={!selectedOptions || (selectedOptions && !selectedOptions.length)}
                        label="Delete"
                        style={{marginRight: '1em'}}
                        onClick={this.deleteSelectedSortOrders}
                    />
                    <Button
                        disabled={!selectedOptions || (selectedOptions && !selectedOptions.length)}
                        label="Toggle Order"
                        onClick={this.updateSortOrder}
                    />
                </div>
            </div>
        );
    }
}

sortOptionList.propTypes = {
    deleteSelectedSortOptions: PropTypes.func.isRequired,
    reorderSortOptionList: PropTypes.func.isRequired,
    shelfType: PropTypes.string.isRequired,
    sortOptions: PropTypes.array.isRequired,
    updateSortOptionList: PropTypes.func.isRequired,
    updateSortOrder: PropTypes.func.isRequired,
};

export default sortOptionList;
